export default "__VITE_ASSET__54dc8338__"